/**
 * Cart Drawer Checkout Extension for Chekly CheckoutManager
 * 
 * Prevents redirect to Chekly checkout for cart drawer buttons.
 */

(function () {
  'use strict';

  function markCartDrawerButtons() {
    const elements = document.querySelectorAll('.cart__ctas a[href="/cart"]');
    elements.forEach((element) => {
      if (element.getAttribute('data-chekly-cart-drawer-prevented') !== 'true') {
        const onclickAttr = element.getAttribute('onclick');
        if (onclickAttr) {
          element.removeAttribute('onclick');
          element.setAttribute('data-original-onclick', onclickAttr);
        }
        element.setAttribute('data-chekly-cart-drawer-prevented', 'true');
        element.setAttribute('chekly-procceded', 'true');
      }
    });
  }

  function setupClickInterceptor() {
    const handleClick = function(e) {
      const link = e.target.closest('.cart__ctas a[href="/cart"]');
      if (link && link.getAttribute('data-chekly-cart-drawer-prevented') === 'true') {
        e.stopImmediatePropagation();
        
        const originalOnclick = link.getAttribute('data-original-onclick');
        if (originalOnclick) {
          try {
            link.classList.add('loading');
            const spinner = link.querySelector('.loading__spinner');
            if (spinner) {
              spinner.classList.remove('hidden');
            }
          } catch (error) {
          }
        }
        
        setTimeout(() => {
          window.location.href = '/cart';
        }, 10);
      }
    };

    ['mousedown', 'touchstart', 'click'].forEach((eventType) => {
      document.addEventListener(eventType, handleClick, { capture: true, passive: false });
    });
  }

  function init() {
    setupClickInterceptor();
    markCartDrawerButtons();
    
    const observer = new MutationObserver(() => {
      markCartDrawerButtons();
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }

    document.addEventListener('DOMContentLoaded', markCartDrawerButtons);
    window.addEventListener('load', markCartDrawerButtons);
  }

  init();
})();
